import React, { Component } from "react";
import Grid from "components/common/Grid";
import Faq from "../../../components/FaqComponent/Faq";
import FaqDeleteModel from "components/FaqComponent/FaqCategoriesModel/FaqDeleteModel";
import KeywordsDrawer from "components/FaqComponent/KeywordsDrawer";
import FaqAddContainer from "../FaqAddContainer";
import DailogFaqDeleteModel from "components/FaqComponent/DailogFaqDeleteModel";
import { FaqApi } from "stores/FaqTableStore/FaqApi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class FaqQuestionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openDialoge: false,
      loading: false,
      openDelete: false,
      category_id: null,
      subcategory_id: null,
      status: 1,
      editQuestionId: null,
      deleteId: null,
      faqstatus: "",
      mode:"view",
      editId:null,
      modeldeletefaq:false,
      idFaqDelete:'',
      faqdeletSuccess:false,
      inputsearch:''
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleViewClose = this.handleViewClose.bind(this);
    this.handleClickOpenDelete = this.handleClickOpenDelete.bind(this);
    this.handleCloseDialogereject = this.handleCloseDialogereject.bind(this);
    this.handleDeleteClickOpen = this.handleDeleteClickOpen.bind(this);
    this.handelChangeFilter = this.handelChangeFilter.bind(this);
    this.onKeywordAdd = this.onKeywordAdd.bind(this);
    this.onKeywordDelete = this.onKeywordDelete.bind(this);
    this.onKeywordUpdate = this.onKeywordUpdate.bind(this);
    this.handleClickDelete = this.handleClickDelete.bind(this);
    
    this.debouncedSearch = debounce(this.performSearch?.bind(this), 500);
  }

  searchhandleChange = (name, value) => {
  
    const query = value;
    this.setState({inputsearch: query });
    this.debouncedSearch(query);
  };

  componentDidMount() {
    const { getFaqTableAction, getCategoriesList, getFaqParentCategories } =
      this.props;
    getFaqTableAction({ status: 1 });
    getCategoriesList();
    getFaqParentCategories({ parent_id: 0 });
  }

  performSearch(searchQuery) {
    this.setState({searchkeyword:searchQuery})
    if (searchQuery) {
      this.props.getFaqTableAction({ status: 1,search:searchQuery });

      return;
    } else this.props.getFaqTableAction({ status: 1 });
  }
  handleDeleteFaqDailogOpen =(id)=>{
    console.log("fefuehef",id);
    
    this.setState({
      modeldeletefaq:true,
      idFaqDelete:id
    })
  }
  handleDeleteFaqDailogClose =()=>{
    this.setState({
      modeldeletefaq:false,
    })
  }
  handleDeleteFaqApi = async () => {
    try {
      const res = await FaqApi.deleteFaqApi(this.state.idFaqDelete);
      if (res && res.status === 1) {
        this.props.getFaqTableAction({ status: 1 });

        this.handleDeleteFaqDailogClose();
        this.setState({faqdeletSuccess:true})
      } else {
        console.warn("Delete operation unsuccessful:", res);
      }
    } catch (error) {
      console.error("Error deleting connector:", error);
    }
  };

  handleClickOpen(id, type) {
    if (type === "delete") {
      this.setState({ openDelete: true, deleteId: id });
    } else {
      this.setState({ openDialoge: true, editQuestionId: id });
      this.props.getFaqKeywordAction({ question_id: id });
    }
  }
  handleViewClose = () => {
    this.setState({ openDialoge: false });
  };
  handleClickOpenDelete = () => {
    this.setState({ openR: true });
  };
  handleCloseDialogereject = () => {
    this.setState({ openDelete: false });
  };
  handleDeleteClickOpen = (id, status) => {
    this.setState({ openDelete: true, deleteId: id, faqstatus: status });
  };

  handelChangeFilter = async (e) => {
    const { name, value } = e.target;

    if (value === "all") {
      if (name === "category_id") {
        this.setState({ [name]: null }, async () => {
          await this.props.getFaqTableAction({
            category_id: this.state.category_id,
          });
          await this.props.getCategoriesList();
        });
      }
      
      else {
        this.setState({ [name]: null }, async () => {
          await this.props.getFaqTableAction({
            category_id: this.state.category_id,
            subcategory_id: this.state.subcategory_id,
          });
          await this.props.getCategoriesList();
        });
      }
    } else {
      this.setState({ [name]: value }, async () => {
        if (name === "category_id") {
          await this.props.getCategoriesList({ parent_id: value });
          await this.props.getFaqTableAction({
            category_id: this.state.category_id,
          });
        }else if ( name === "content_type"){
          this.setState({ [name]: null }, async () => {
            await this.props.getFaqParentCategories({ parent_id: 0 ,content_type:value});
            await this.props.getFaqTableAction({
              content_type: value,
            });
          });
        }
         else {
          await this.props.getFaqTableAction({
            category_id: this.state.category_id,
            subcategory_id: this.state.subcategory_id,
          });
        }
      });
    }
  };

  onKeywordAdd = async (data) => {
    const { editQuestionId } = this.state;
    const payload = {
      question_id: editQuestionId,
      name: data,
    };
    await this.props.postFaqKeywordAction(payload);

    setTimeout(() => {
      this.props.getFaqKeywordAction({ question_id: editQuestionId });
    }, 1000);
  };

  onKeywordDelete = async (data) => {
    const { editQuestionId } = this.state;
    await this.props.deleteFaqKeyword(data);
    this.props.snackbarAction({
      open: true,
      message: 'keyword delete successfully',
      severity: "success",
  })
    // setTimeout(() => {
      this.props.getFaqKeywordAction({ question_id: editQuestionId });
    // }, 1000);
  };

  onKeywordUpdate = async (data) => {
    const { editQuestionId } = this.state;
    await this.props.updateFaqKeywordAction(data);
    this.props.snackbarAction({
      open: true,
      message: 'keyword update successfully',
      severity: "success",
  })

    // setTimeout(() => {
      this.props.getFaqKeywordAction({ question_id: editQuestionId });
    // }, 1000);
  };


  handleClickDelete = async () => {
    const { faqstatus, deleteId } = this.state;
    await this.props.updateFaq({
      id: deleteId,
      status: faqstatus.toString(),
    });
    // setTimeout(() => {
      this.props.getFaqTableAction({
        category_id: this.state.category_id,
        subcategory_id: this.state.subcategory_id,
      });
    // }, 1000);
    this.setState({ openDelete: false });
  };

  handleEditClick = (id) => {

    this.setState({mode:"update",editId:id})
  }

  handleEditSuccess = () => {
    // Set mode to "view" and fetch the updated FAQ table
    this.setState({ mode: "view" }, () => {
      this.props.getFaqTableAction({ status: 1 });
    });
  };
  

  render() {
    const {
      // FaqTableList,
      // CategoriesList,
      FaqKeywordList,
      // ParentCategoriesList,
      FaqKeywordIsLoading,
      // isloadingFaqTable,
    } = this.props;
    const { mode, editId } = this.state;

    if (mode === "update") {
      return (
        <FaqAddContainer 
          id={editId}
          handleBack={()=>this.handleEditSuccess()}
          onEditSuccess={this.handleEditSuccess}  
        />
      );
    }

    return (
      <>
        <Grid
          container
          spacing={2}
          style={{
            width: "100%",
            margin: "0px",
          }}
        >
          <Faq
            data={this.props.FaqTableList}
            category={this.props.CategoriesList}
            ParentCategoriesList={this.props.ParentCategoriesList}
            handleClickOpen={this.handleClickOpen}
            handleDeleteClickOpen={this.handleDeleteClickOpen}
            handelChangeFilter={this.handelChangeFilter}
            isloadingFaqTable={this.props.isloadingFaqTable}
            handleEditClick={this.handleEditClick}
            selectedVal={this.state}
            handleDeleteFaqDailogOpen={this.handleDeleteFaqDailogOpen}
            searchhandleChange={this.searchhandleChange}
          />
          <DailogFaqDeleteModel
          open={this.state.modeldeletefaq}
          handleClose={this.handleDeleteFaqDailogClose}
          handleDelete={this.handleDeleteFaqApi}


          />
          <FaqDeleteModel
            open={this.state.openDelete}
            handleCloseDialoge={this.handleCloseDialogereject}
            onClickModel={this.handleClickDelete}
            faqstatus={this.state.faqstatus}
          />
          <KeywordsDrawer
            open={this.state.openDialoge}
            onClose={() => this.setState({ openDialoge: false })}
            data={FaqKeywordList}
            onKeywordAdd={this.onKeywordAdd}
            onKeywordDelete={this.onKeywordDelete}
            onKeywordUpdate={this.onKeywordUpdate}
            isLoading={FaqKeywordIsLoading}
          />
        </Grid>
        <Snackbar
              open={this.state.faqdeletSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ faqdeletSuccess: false })}
              message="bulk add Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">Faq Delete Successfully</Alert>
            </Snackbar>
      </>
    );
  }
}
